import Col from "components/ui-elements/Col";
import React from "react";
import DatetimepickerMy from "./DatetimepickerMy";

const DatetimepickerCol = (props) => {
  const { colsize, model, margin, ...rest } = props
  return (
    <Col size={colsize} model={model} margin={margin}>
      <DatetimepickerMy {...rest} />
    </Col>
  );
};

DatetimepickerCol.defaultProps = {
  colsize: 12,
  model: "md",
  margin: "mb-1"
}

export default DatetimepickerCol;